import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { Button, Table, TableHeader, TableBody, TableRow, TableHead, } from '@cargomatic/ui';
import CargomaticCollapsibleCard from 'components/v2/CollapsibleCard';
import { Plus } from 'lucide-react';
import EquipmentStore from 'stores/EquipmentStore';
import EquipmentItem from './equipments/EquipmentItem';
import AddEquipmentModal from './AddEquipmentModal';
import OrdersActionCreators from '../../../actions/OrdersActionCreators';
import EquipmentActionCreators from '../../../actions/EquipmentActionCreators';
class EquipmentsList extends Component {
    constructor(props) {
        super(props);
        this.handleAddEquipment = () => {
            this.setState({ showAddModal: true });
        };
        this.handleEquipmentStoreChange = () => {
            const equipmentList = EquipmentStore.getEquipment();
            if (!equipmentList || equipmentList.length === 0) {
                return;
            }
            const lastIndex = equipmentList.length - 1;
            const equipment = equipmentList[lastIndex];
            const equipments = this.props.order.equipments || [];
            // equipment already added to the order
            if (equipments.map((eq) => eq._id).includes(equipment._id)) {
                return;
            }
            this.handleEquipmentSelect(equipment);
        };
        this.handleCreateEquipment = (equipment) => EquipmentActionCreators.addEquipment(equipment);
        this.handleEquipmentSelect = (equipment) => {
            const equipments = this.props.order.equipments || [];
            // equipment already added to the order
            if (equipments.map((eq) => eq._id).includes(equipment._id)) {
                return;
            }
            OrdersActionCreators.addEquipmentToOrder(this.props.order._id, equipment._id);
        };
        this.state = {
            showAddModal: false,
        };
    }
    componentDidMount() {
        EquipmentStore.addChangeListener(this.handleEquipmentStoreChange);
    }
    componentWillUnmount() {
        EquipmentStore.removeChangeListener(this.handleEquipmentStoreChange);
    }
    render() {
        const { order, shipments, t } = this.props;
        return (React.createElement(CargomaticCollapsibleCard, { id: "order-equipment-details", header: () => (React.createElement("div", { className: "flex items-center gap-3 w-full" },
                React.createElement("span", null, t('EQUIPMENT_DETAILS')),
                React.createElement(Button, { size: "sm", variant: "default", onClick: () => this.handleAddEquipment(), "data-testid": "add-equipment-button" },
                    React.createElement(Plus, { className: "h-4 w-4 mr-1", strokeWidth: 2.5 }),
                    titleize(t('ADD'))))) },
            React.createElement("div", { className: "overflow-x-auto" },
                React.createElement(Table, null,
                    React.createElement(TableHeader, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableHead, { className: "whitespace-nowrap" }, titleize(t('EQUIPMENT_ID'))),
                            React.createElement(TableHead, { className: "whitespace-nowrap" }, titleize(t('TYPE'))),
                            React.createElement(TableHead, { className: "whitespace-nowrap" }, titleize(t('SIZE', { count: 1 }))),
                            React.createElement(TableHead, { className: "whitespace-nowrap" }, titleize(t('DATE', { count: 2 }))),
                            React.createElement(TableHead, { className: "whitespace-nowrap" }, titleize(t('ATTACHED_TO_SHIPMENT'))),
                            React.createElement(TableHead, null))),
                    React.createElement(TableBody, null, order.equipments.map((eq, idx) => {
                        return (React.createElement(EquipmentItem, { key: eq.equipment_id + idx, order: order, shipments: shipments, equipment: eq }));
                    })))),
            this.state.showAddModal && (React.createElement(AddEquipmentModal, { show: this.state.showAddModal, onClose: () => this.setState({ showAddModal: false }), onCreateEquipment: this.handleCreateEquipment, onEquipmentSelect: this.handleEquipmentSelect }))));
    }
}
EquipmentsList.propTypes = {
    order: PropTypes.object,
};
export default withTranslation()(EquipmentsList);
